/* eslint-disable react/jsx-props-no-spreading */
import { compose } from 'redux';
import { Query } from '@apollo/client/react/components';
import hoistStatics from 'hoist-non-react-statics';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ErrorHandler } from '@playbookux/playbook-web-core';
import { Container, Loader } from './styles';
import ProjectSidebar from '../project-sidebar';
import withLayout from '../../../core/components/with-layout';
import GET_PROJECT_BY_ID from './graphql';

export default (options = {}) => (WrappedComponent) => {
  const {
    showSideBar = true,
  } = options;
  class WithProjectSidebar extends Component {
    constructor(props) {
      super(props);

      const { match } = props;
      const { params } = match;
      const { projectId } = params;

      const isDemoProject = projectId === '00000000-0000-0000-0000-000000000000';

      this.state = {
        isDemoLoading: isDemoProject,
        isDemoProject,
        projectAnalyticsData: {},
        projectData: {},
      };
    }

    async componentDidMount() {
      const { isDemoProject } = this.state;

      if (isDemoProject) {
        this.setState({
          isDemoLoading: true,
        });

        const { projectData, projectAnalyticsData } = await import('../../demo-project');

        this.setState({
          isDemoLoading: false,
          projectAnalyticsData,
          projectData,
        });
      }
    }

    render() {
      const { ...props } = this.props;

      const { active, match } = props;
      const { params } = match;
      const { projectId } = params;

      const {
        isDemoLoading,
        isDemoProject,
        projectAnalyticsData,
        projectData,
      } = this.state;

      const queryVariables = { id: projectId };

      if (isDemoProject) {
        if (isDemoLoading) {
          return <Loader data-loader="demo-project-loader" />;
        }

        return (
          <Container showSideBar={showSideBar}>
            {showSideBar && <ProjectSidebar active={active} project={projectData} />}

            <WrappedComponent
              project={projectData}
              analytics={projectAnalyticsData}
              {...props}
            />
          </Container>
        );
      }
      return (
        <Query fetchPolicy="cache-first" query={GET_PROJECT_BY_ID} variables={queryVariables}>
          {({
            loading,
            error,
            data,
            refetch,
          }) => {
            if (loading) {
              return <Loader data-loader="project-loader" />;
            }

            if (error) {
              return (
                <ErrorHandler
                  error={error}
                  defaultMessage="Error while retrieving project details."
                />
              );
            }

            const {
              project,
              cardSortItems,
              cardSortCategories,
            } = data;

            const updatedProject = {
              ...project,
              cardSortItems,
              cardSortCategories,
            };

            return (
              <Container showSideBar={showSideBar}>
                {showSideBar && <ProjectSidebar active={active} project={project} />}

                <WrappedComponent
                  project={updatedProject}
                  refetch={refetch}
                  {...props}
                />
              </Container>
            );
          }}
        </Query>
      );
    }
  }

  WithProjectSidebar.propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        projectId: PropTypes.string,
      }),
    }).isRequired,
  };

  return compose(
    withLayout({ showLogo: !showSideBar, ...options }),
  )(hoistStatics(WithProjectSidebar, WrappedComponent));
};
